var resm_module_interface = (function (resm_module_interface) {
  resm_module_interface.init = function () {
    $("#gptw-wrapper").on(
      "click",
      ".gptw-legend .gptw-legend-header > a",
      function (event) {
        event.preventDefault();
        if (!$("#gptw-wrapper .gptw-legend").hasClass("active")) {
          $("#gptw-wrapper .gptw-legend").addClass("active");
          $("#gptw-wrapper .gptw-legend .gptw-legend-content")[0].scrollTop = 0;
        } else {
          $("#gptw-wrapper .gptw-legend").removeClass("active");
        }
      }
    );

    var simpleBar = new SimpleBar($("#gptw-wrapper .gptw-legend-scroll")[0]);
  };
  resm_module_interface.closePanel = function () {
    $("#gptw-wrapper .gptw-legend").removeClass("active");
  };

  return resm_module_interface;
})(resm_module_interface || {});
